export default ({baseArr = [], searchArr = []}) => {
  return searchArr.length
    ? searchArr?.map((searchItem) => {
        return baseArr?.find((baseItem) => baseItem.id === searchItem.id);
    })
    : baseArr;
};
